module.exports = __webpack_public_path__ + "img/mon_256.7acddf61.png";